var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('Sipariş Notu'),expression:"'Sipariş Notu'",modifiers:{"bottom":true}}],class:['badge-wrapper', _vm.getBadgeClass]},[_vm._v(" "+_vm._s(_vm.getValue)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }